<template>
    <span>

        <v-text-field v-model="model" :pattern="pattern"
            v-bind="{ value, loading, multiple, label, hint, placeholder, outlined, persistentHint, clearable, disabled, singleLine, prependIcon, appendIcon, rules, errorMessages, prefix, suffix }"
            @blur="hasFocus = false"
            @focus="hasFocus = true"
            @keypress="onKeyPress($event)"
            ></v-text-field>
        <input v-if="name" :name="name" :value="val" type="hidden" />

    </span>
</template>
<script>
export default {
    name: "FloatInput",
    props: {
        name: {},
        value: {},
        loading: {},
        multiple: {},
        label: {},
        hint: {},
        placeholder: {},

        outlined: {}, dense: {}, filled: {}, solo: {}, dark: {}, color: {},

        persistentHint: {},
        clearable: {},
        disabled: {},
        singleLine: {},
        appendIcon: {}, prependIcon: {},
        prefix: {},
        suffix: {},

        rules: { default() { return []; } },
        errorMessages: { type: Array },


        decimals: { type: Number, default: null },
    },
    data() {
        let val = parseFloat(this.value);
        if (isNaN(val))
            val = null;
        return {
            val,
            hasFocus: false,
        };
    },
    computed: {
        pattern() {
            return '^[0-9]+' + (this.decimals > 0 ? '(\\.[0-9]{0,' + this.decimals + '}|)' : '') + '$';
        },
        model: {
            get() {
                return this.decimals && !this.hasFocus ?
                    (isNaN((this.val) || this.val === null) ? '' : (this.val ?? 0).toFixed(this.decimals))
                    : this.val;
            },
            set(v) {
                if (parseFloat(this.val) !== parseFloat(v)) {
                    v = parseFloat(v);
                    if(isNaN(v))
                        v = 0;

                    if(this.decimals){
                        v = parseFloat(v.toFixed(this.decimals));
                    }

                    this.val = v;
                    this.$emit('input', v);
                }
            },
        }
    },
    methods: {

        onKeyPress(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (
                ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46)
                || (charCode === 46 && this.val.toString().indexOf('.') >= 0)
                //|| (this.decimals && this.val && !(this.val + String.fromCharCode(charCode)).match(new RegExp(this.pattern)))
            ) {
                evt.preventDefault();
                return false;
            }
            return true;
        },

    },
    watch:{
        value() {
            let val = parseFloat(this.value);
            if (isNaN(val))
                val = null;
            this.val = val;
        }
    }
}
</script>